// extracted by mini-css-extract-plugin
module.exports = {"formChangeBg":"ChangeBgModal_formChangeBg__lzc3Z","buttonChangeBg":"ChangeBgModal_buttonChangeBg__3sZ_s"};